import { render } from "./PlanYourVisit.vue?vue&type=template&id=226a4913&scoped=true"
import script from "./PlanYourVisit.vue?vue&type=script&lang=js"
export * from "./PlanYourVisit.vue?vue&type=script&lang=js"

import "./PlanYourVisit.scss?vue&type=style&index=0&id=226a4913&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226a4913"]])

export default __exports__